var React = require('react');

function Forward (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"})));
}

Forward.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Forward;

Forward.default = Forward;
